import { useMemo } from 'react';
import { createOption } from '@mews-commander/ui';
import { useLanguages } from '../../../../../../../core/globalization';

export const useLanguageOptions = () => {
    const { data: languages = [], isLoading } = useLanguages();
    const options = useMemo(() => {
        return languages
            .filter((lang): lang is { code: string; englishName?: string } => Boolean(lang))
            .map(({ code, englishName }) =>
                createOption({
                    value: code,
                    label: englishName || code,
                })
            );
    }, [languages]);

    return { languages: options, isLoading };
};
